module.exports = __webpack_public_path__ + "static/img/9@2x.f3ba7575.png";